module.exports = __webpack_public_path__ + "static/avril-party0-7cf0df421883ade32568842dfd47ff6e.gif";